import { render } from "./WaveB.vue?vue&type=template&id=c0c308d6&scoped=true"
import script from "./WaveB.vue?vue&type=script&lang=js"
export * from "./WaveB.vue?vue&type=script&lang=js"

import "./WaveB.vue?vue&type=style&index=0&id=c0c308d6&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c308d6"]])

export default __exports__